<div class="row breadcrumb" id="home-menu">
  <div class="po-md-3 po-lg-2 po-sm-2 po-xl-2 modulo">
    <span class="po-icon po-icon-cart"></span>
    <span style="font-size: 13px; margin-left: 5px;"><b>Módulo lojas</b></span>
  </div>
  <div class="po-md-9 po-lg-10 po-sm-10 po-xl-10 align-text-right menu-text">
    <po-breadcrumb [p-items]="message"></po-breadcrumb>
  </div>
</div>